export default __webpack_public_path__ + "static/media/tabs-home.54e6f5dc.svg";